import {FormError} from './FormError.js'

export class ConfigurationNotFoundFormError extends FormError {}
